import script from "./Pagination.vue?vue&type=script&setup=true&name=Pagination&lang=js"
export * from "./Pagination.vue?vue&type=script&setup=true&name=Pagination&lang=js"

import "./Pagination.vue?vue&type=style&index=0&id=027f6db5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-027f6db5"]])

export default __exports__